const DEFAULT_FILTERS_PAGE_URL = '/filters';

const TENANT_LOGIN_PAGE_URL = '/login-page';

const PUBLIC_URL_PATH_LIST = [
    '/email-verification',
    '/forgot-password',
    '/login',
    '/privacy-policy',
    '/register',
    '/requests',
    '/reset-password',
    '/surveys',
    '/404',
    '/500',
    '/attachments'
];

const FULL_QUERY_SUPPORTED_PATH_LIST = [
    '/admin/ticket-fields',
    '/admin/user-fields',
    '/admin/organization-fields',
    '/admin/ticket-forms',
    '/admin/advanced-reports'
];

const TENANT_ID_NOT_REQUIRED_PATH_LIST = ['/login', '/privacy-policy', '/register', '/404', '/500'];

export {
    DEFAULT_FILTERS_PAGE_URL,
    FULL_QUERY_SUPPORTED_PATH_LIST,
    PUBLIC_URL_PATH_LIST,
    TENANT_ID_NOT_REQUIRED_PATH_LIST,
    TENANT_LOGIN_PAGE_URL
};
